import React from 'react'
import { Box } from '@twilio-paste/core/box'
import { Button } from '@twilio-paste/core/button'

const Buttons = ({ curInteractives, sendMessage }) => {
  return (
    <Box display='flex' flexWrap='wrap' width='100%' rowGap='space20' columnGap='space20'>
      {curInteractives.options.map((o) => (
        <Button key={o.uuid} onClick={() => sendMessage(o.value)} variant='secondary'>
          {o.content}
        </Button>
      ))}
    </Box>
  )
}

export default Buttons
